import React from "react";
import SearchBar from "./components/SearchBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { TableWrapper } from "../languagesPairList/LanguagesPairListPage";
import Loading from "@/common/components/Loading";
import CustomAddButton from "@/common/components/custom/buttons/CustomAddButton";
import AdminEdit from "./components/AdminEdit";
import PaginatedDataTableFilter from "./components/serverPaginatedDataTable/ServerPaginatedDataTableFilter";
import { TopContent, Wrapper } from "./AdminWordListPage.styled";
import useAdminWordListPage from "./hooks/useAdminWordListPage";

const AdminWordListPage = () => {
  const {
    isSomeMutationPending,
    addWord,
    setAddWord,
    options,
    selectedLang,
    setSelectedLang,
    setSelectedType,
    selectedType,
    selectedLevel,
    setSelectedLevel,
    handleSearch,
    checkIfIncludeSentence,
    limit,
    setLimit,
    skip,
    setSkip,
    itemsTotal,
    isLoading,
    filtersChangeHandler,
    sortingChangeHandler,
    tableData,
    HEADERS,
  } = useAdminWordListPage();

  return (
    <>
      {isSomeMutationPending && <Loading />}
      {addWord && (
        <AdminEdit edit={addWord} setEdit={setAddWord} languages={options} />
      )}
      <Wrapper>
        <SearchBar
          options={options}
          selectedLang={selectedLang}
          setSelectedLang={setSelectedLang}
          setSelectedType={setSelectedType}
          selectedType={selectedType}
          selectedLevel={selectedLevel}
          setSelectedLevel={setSelectedLevel}
          handleSearch={handleSearch}
          checkIfIncludeSentence={checkIfIncludeSentence}
        />
        <TopContent>
          <CustomAddButton
            onClick={() => setAddWord({})}
            text={<FontAwesomeIcon icon={faAdd} style={{ color: "white" }} />}
          />
        </TopContent>
        <TableWrapper>
          <PaginatedDataTableFilter
            limit={limit}
            onFiltersChange={filtersChangeHandler}
            onSortingChange={sortingChangeHandler}
            setLimit={setLimit}
            setSkip={setSkip}
            skip={skip}
            totalLength={itemsTotal}
            isLoading={isLoading}
            data={tableData}
            columns={HEADERS}
          />
        </TableWrapper>
      </Wrapper>
    </>
  );
};

export default AdminWordListPage;
